export const roadB05 = [
      {
        id: 0,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",
        title: "Link",
        subtitle: "B2/C1",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
           

        ],
    },
    {
        id: 1,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",
        title: "Welcome ",
        subtitle: "B2/C1",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo:"Welcome ",descripcion:"Bienvenidos estudiantes",url3:"https://drive.google.com/file/d/1NcEm9JGaCnXFhWKHNHFqxSe52ZyilqEw/view?usp=sharing"},
            

        ],
    },
     {
        id: 2,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",
        title: "Book and Pearson Platform ",
        subtitle: "B2/C1",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
          { titulo:"¿Cómo crear una cuenta en la Plataforma Pearson ",descripcion:"Tutorial",url3:"https://drive.google.com/file/d/1Y8cX_33u8MqgmF7w6FyUPfUfxfiXGG-K/view?usp=sharing"},
          { titulo:"¿Cómo activar mi libro Speakout ",descripcion:"Tutorial",url3:"https://drive.google.com/file/d/1Sink5UpCaycE1DdS1bEuGyJ1pys44GvH/view?usp=sharing"},
          { titulo:"¿Cómo enrolarme al curso creado por mi docente ",descripcion:"Tutorial",url3:"https://drive.google.com/file/d/1cw7NMUlxqwmCgDEToAtKndDdItz4h6vd/view?usp=sharing"},
          { titulo:"La nueva versión de la Plataforma Pearson ",descripcion:"Tutorial",url3:"https://drive.google.com/file/d/1TAXsvsbyXrfwipjaIFjhDMXtXqlM8j7o/view?usp=sharing"},
          { titulo:"La nueva versión de la Plataforma Pearson ",descripcion:"Tutorial",url2:"https://drive.google.com/file/d/1zlGVAoWb-Pixdgtq0YtPeTv5aTQRDW9m/view?usp=sharing"},


        ],
    },
   {
        id: 3,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Student materials & Resources",
        subtitle: "B2/C1",
       
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [

         { titulo:"Handbook Students",descripcion:"important Info for the students",url: "https://drive.google.com/file/d/1S4-rdH5n-bk2qmKRxcKa2xhI4rf6oo58/view?usp=sharing"},
        

          
        ],
    },
     {
        id: 4,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",
        title: "Slides",
        subtitle: "B2/C1",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Completa los desafíos para dominar el Inglés",
        enlaces: [
            { titulo:"Have got",descripcion:"Learn How to use Have got",url:"https://drive.google.com/file/d/1Lbn1vP0ON4Pv5hUiqh870hrfC-X0j3df/view?usp=sharing"},
            { titulo:"How much and How many",descripcion:"Learn How to use it",url:"https://drive.google.com/file/d/1dYrsWPqUjL3jrNj7ZiYWkoHDRGcJA0ta/view?usp=sharing"},
            { titulo:"Past of Be",descripcion:"Learn How to use it",url:"https://drive.google.com/file/d/1M_Xs0JBvLQeD8itlmHx7yc1Y-4-0b8fN/view?usp=sharing"},
            { titulo:"Preent simple ",descripcion:"Learn How to use it with I you we they",url:"https://drive.google.com/file/d/1UyRwnuD1Vel7T1jSkPQzQkoF2tLAXgR3/view?usp=sharing"},
            { titulo:"Should and Should not ",descripcion:"Learn How to use it ",url:"https://drive.google.com/file/d/1jh0UGSLnI5R9aDVDBFbaw9yKSqi07ZZu/view?usp=sharing"},
            { titulo:"There is and There are",descripcion:"Learn How to use it ",url:"https://drive.google.com/file/d/1lO8kjf8CNZj6mn3nmtGJFGRt_imQV0y4/view?usp=sharing"},
            { titulo:"THIS, THAT, THESE, THOSE, HERE, THERE",descripcion:"Learn How to use it ",url:"https://drive.google.com/file/d/1VIK3ZTMyr1GeuAhJjsOt-hTCBhlhObqt/view?usp=sharing"},

        ],
    },
     {
        id: 5,
        thumbnail: "https://i.ibb.co/XZWjhLHS/DALL-E-2025-03-13-12-36-11-A-powerful-warrior-representing-the-Present-Simple-tense-in-English-gramm.webp",

        title: "Teacher materials & Resources",
        subtitle: "B2/C1",
        code:"continentalteacher",
        dateAdded: "Basic 01 ",
        channel: "sdasd",
        description: "Entiende como usar cada matiz gramatical",
        enlaces: [
         { titulo:"Syllaus for teachers",descripcion:"Important info for the teachers",url:"https://drive.google.com/file/d/1-5NrrPPVqRmOhmJpFMZemw6FSeHHBWLV/view?usp=sharing"},

         { titulo:"Teacher Handbook",descripcion:"Important info for the teachers",url:"https://drive.google.com/file/d/1Z0entF1foRxQ_gtgskX6E3w_efLxAGke/view?usp=sharing"},
        
        ],
    }
   
   
];
